// One place to decide where a child stands in an internship programme.
export const STAGE_LABEL = {
  applications_open: 'Applications open',
  applied: 'Application submitted',
  under_review: 'Under review',
  placement_confirmed: 'Confirm participation',
  in_progress: 'Internship confirmed',
  completed: 'Completed',
  partially_completed: 'Partially completed',
  not_completed: 'Not completed',
  withdrawn: 'Withdrawn',
  not_selected: 'Not selected',
  closed: 'Closed',
};

export const STAGE_TONE = {
  placement_confirmed: 'bg-[#FFF0ED] text-[#F06651]',
  applications_open: 'bg-emerald-50 text-emerald-600',
  in_progress: 'bg-emerald-500 text-white',
  completed: 'bg-emerald-500 text-white',
  applied: 'bg-blue-50 text-blue-700',
  under_review: 'bg-blue-50 text-blue-700',
};

// lower rank = needs the family sooner
const RANK = {
  placement_confirmed: 0, applications_open: 1, in_progress: 2, applied: 3, under_review: 3,
  completed: 5, partially_completed: 5, not_completed: 5, withdrawn: 6, not_selected: 6, closed: 7,
};

export const stageRank = (stage) => (stage in RANK ? RANK[stage] : 8);
export const isHistory = (stage) =>
  ['completed', 'partially_completed', 'not_completed', 'withdrawn', 'not_selected', 'closed'].includes(stage);

export function journeyStage({ application, placement, program, eligible }) {
  if (placement) {
    if (placement.withdrawal?.status === 'approved') return 'withdrawn';
    const outcome = placement.completion?.school_status;
    if (outcome) return outcome;                       // completed | partially_completed | not_completed
    if (placement.participation?.status !== 'confirmed') return 'placement_confirmed';
    return 'in_progress';
  }
  if (application?.final_status === 'not_selected') return 'not_selected';
  if (application?.status === 'submitted') {
    return program?.applications_open ? 'applied' : 'under_review';
  }
  if (program?.applications_open && eligible) return 'applications_open';
  return 'closed';
}
